import {
  AvatarWithDetailsSkeleton,
  CurrentUserAvatar,
  OrganizationAvatar,
} from "@facade/shared";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@facade/components/ui";

import { AccountInfo } from "@facade/features/account";
import { OrganizationInfo } from "@facade/features/organization";
import { Project } from "@facade/contracts";
import { Suspense } from "react";

export function ProjectOwnerAvatar({ project }: { project: Project }) {
  const isOrganizationProject = project.ownerType === "ORGANIZATION";

  return (
    <HoverCard openDelay={150} closeDelay={100}>
      <HoverCardTrigger asChild>
        <span className="absolute right-0 bottom-0 translate-x-[20%] translate-y-[20%]">
          {isOrganizationProject ? (
            <OrganizationAvatar
              size="sm"
              name={project.owner.name}
              imageAttachmentId={project.owner.imageId}
              organizationId={project.owner.id}
              avatarImageVariation="small"
            />
          ) : (
            <CurrentUserAvatar size="sm" avatarImageVariation="small" />
          )}
        </span>
      </HoverCardTrigger>

      <HoverCardContent
        side="right"
        align="start"
        sideOffset={8}
        className="min-w-42 p-0"
      >
        <Suspense fallback={<AvatarWithDetailsSkeleton className="p-4" />}>
          <div className="flex flex-col overflow-hidden">
            <div className="flex items-center gap-4 p-2 overflow-hidden">
              {isOrganizationProject ? (
                <OrganizationInfo
                  organizationId={project.owner.id}
                  avatarImageVariation="original"
                  size="xl"
                />
              ) : (
                <AccountInfo />
              )}
            </div>
          </div>
        </Suspense>
      </HoverCardContent>
    </HoverCard>
  );
}
